/** @jsxRuntime classic */
/** @jsx jsx */
import { gql } from '@apollo/client';
import { useLocation } from '@reach/router';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import Product_fullName from '../../../fragments/Product/fullName';
import ShoppingCartButton from './ShoppingCartButton';

export default function ProductSnipcartButton({ product, children, ...rest }) {
  const { href } = useLocation();
  return (
    <ShoppingCartButton
      data-item-id={product.inventoryId || product.productId}
      data-item-url={href}
      data-item-name={product.fullName}
      data-item-description={product.description}
      data-item-image={product.shopImage?.fixed?.src}
      {...rest}
      className={`snipcart-add-item ${rest.className}`}
    >
      {children}
    </ShoppingCartButton>
  );
}

export const fragment = graphql`
  fragment bb_ProductSnipcartButton on Bottlebooks_Product {
    inventoryId
    productId
    description
    shopImage: bottleImage {
      fixed(width: 80, height: 80, crop: PAD, background: "#FFF0") {
        src
      }
    }
    ...bb_Product_fullName
  }
`;

ProductSnipcartButton.fragment = gql`
  fragment ProductSnipcartButton on Product {
    inventoryId
    productId
    description
    shopImage: bottleImage {
      fixed(width: 80, height: 80, crop: PAD, background: "#FFF0") {
        src
      }
    }
    ...Product_fullName
  }
  ${Product_fullName.fragment}
`;
